import React from "react";

type ScoutMarkSize = "sm" | "md" | "lg";
type ScoutMarkVariant = "inline" | "block";

interface ScoutMarkProps {
  size?: ScoutMarkSize;
  variant?: ScoutMarkVariant;
  className?: string;
  /** Override text color; defaults to #6C3FE8 */
  colorClassName?: string;
  /** Vertical pixel nudge to fine-tune baseline alignment. Positive moves down. */
  nudgePx?: number;
  /** Icon height in em units (width auto to preserve AR). Defaults to 1em. */
  iconEm?: number;
}

const sizeToImgClass: Record<ScoutMarkSize, string> = {
  sm: "h-4 w-auto",
  md: "h-5 w-auto",
  lg: "h-6 w-auto",
};

// Text size should inherit from the surrounding context; we purposely avoid
// applying any Tailwind font-size utility to the text. The mapping is kept
// for future extension but currently unused.
const sizeToTextClass: Record<ScoutMarkSize, string> = {
  sm: "",
  md: "",
  lg: "",
};

export const ScoutMark: React.FC<ScoutMarkProps> = ({
  size = "sm",
  variant = "inline",
  className = "",
  colorClassName,
  nudgePx = 1,
  iconEm = 1,
}) => {
  const containerBase = variant === "inline" ? "inline-flex items-baseline" : "inline-flex";
  // Default: gradient text; if colorClassName is provided, it will override
  const colorClass = colorClassName ?? "text-transparent bg-clip-text";

  return (
    <span className={`${containerBase} items-center gap-1 ${className}`}>
      <img
        src="/uploads/scout-icon-dark.png"
        alt="Scout AI logo"
        className={`align-text-bottom`}
        style={{ transform: `translateY(${nudgePx}px)`, height: `${iconEm}em`, width: 'auto' }}
        loading="eager"
        decoding="async"
      />
      <span
        className={`font-sans font-bold ${colorClass}`}
        style={
          colorClassName
            ? undefined
            : { backgroundImage: "linear-gradient(45deg, #C133FF 0%, #B100FF 50%, #8E00CC 100%)" }
        }
      >
        Scout AI
      </span>
    </span>
  );
};

export default ScoutMark;


